import { IOpData, IOpChangeState, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpAlarmGroupData implements IOpData, IOpChangeState, ICopyable<OpAlarmGroupData> {

    // #region Properties

    public idAlarmGroupData: number
    public idAlarmGroup: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // #endregion

    // #region NavigationProperties

    private _dataType: OpDataType = null
    public get dataType(): OpDataType {
        return this._dataType
    }

    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value != null ? value.idDataType : null
    }

    // #endregion

    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpAlarmGroupData) {
            this.copy(<OpAlarmGroupData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion

    // #region IOpChangeState

    public opState: Enums.OpChangeState

    // #endregion

    // #region IOpData

    public get idData(): number { return this.idAlarmGroupData }
    public set idData(idData: number) { this.idAlarmGroupData = idData }
    public get indexNBR(): number { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // #endregion

    //#endregion IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null

            this.idAlarmGroupData = opObj.ID_ALARM_GROUP_DATA
            this.idAlarmGroup = opObj.ID_ALARM_GROUP
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ALARM_GROUP_DATA: this.idAlarmGroupData,
            ID_ALARM_GROUP: this.idAlarmGroup,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            OpState: this.opState
        }
    }

    // #endregion

    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpAlarmGroupData {
        const data: OpAlarmGroupData = new OpAlarmGroupData(null)

        data.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return data
    }

    public copy(source: OpAlarmGroupData, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {
        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.dataType = source.dataType == null ? null : source.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idAlarmGroupData = source.idAlarmGroupData
        this.idAlarmGroup = source.idAlarmGroup
        this.idDataType = source.idDataType
        this.indexNbr = source.indexNbr
        this.value = source.value
        this.opState = source.opState
    }

    // #endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpAlarmGroupData {
        const newData: OpAlarmGroupData = new OpAlarmGroupData(null)

        newData.idAlarmGroupData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}